import { createSelector } from "reselect";
import { getAuctionPens, getMLASupplementaryData } from "selectors";

export const getMLASupplementaryDataById = mlaSupplementaryDataId => state =>
  getMLASupplementaryData(state)[mlaSupplementaryDataId] || null;

export const selectMLASupplementaryDataSaleLotIdsByAuctionPenIdLookup =
  createSelector(
    [getMLASupplementaryData],
    (mlaSupplementaryDataLookup: Record<string, MLASupplementaryData>) =>
      Object.values(mlaSupplementaryDataLookup).reduce(
        (acc, { saleLot }) => {
          const auctionPenId = saleLot?.auctionPenId;
          if (auctionPenId) {
            acc[auctionPenId] = acc[auctionPenId] || [];
            acc[auctionPenId].push(saleLot.id);
          }
          return acc;
        },
        {} as Record<string, string[]>,
      ),
  );

export const selectSaleRoundIdByMLASupplementaryDataSaleLotIdLookup =
  createSelector(
    [getMLASupplementaryData, getAuctionPens],
    (
      mlaSupplementaryDataLookup: Record<string, MLASupplementaryData>,
      auctionPens,
    ) =>
      Object.values(mlaSupplementaryDataLookup).reduce(
        (acc, { saleLot }) => {
          acc[saleLot?.id] = auctionPens[saleLot?.auctionPenId]?.saleRoundId;
          return acc;
        },
        {} as Record<string, number>,
      ),
  );
